import { render, staticRenderFns } from "./BauComplementWizard.vue?vue&type=template&id=a25fb874"
import script from "./BauComplementWizard.vue?vue&type=script&lang=js"
export * from "./BauComplementWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports